import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GlobalService } from 'app/global/global.service';
import { TemplateService } from '../templates.service';
import { RecipientfieldsService } from '../../settings/recipientfields/recipientfields.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { contentBlock } from 'app/interfaces/contentBlock';
import uuid from 'short-unique-id';
import { HelperService } from '../../edit-template/helper.service';
import { Observable, of } from 'rxjs';
import { TemplateType } from '../template.dto';
import { steps } from '../../edit-template/eform-steps.dto';
import { TranslocoService } from '@jsverse/transloco';
import { InvitationThroughEnum } from '../../general-editor-tabs/recipients-tab/recipient-tab.dto';

@Component({
  selector: 'app-add-new-template',
  templateUrl: './add-new-template.component.html',
  styleUrl: './add-new-template.component.scss'
})
export class AddNewTemplateComponent implements OnInit {
  
  @Input() canBuildTemplates$: Observable<boolean> = of(false);
  
  public add_template_form: FormGroup;
  public submitted = false;
  public uuid = new uuid({ length: 6, dictionary: 'number' });
  public addTemaplteLoadder:boolean = false;
  private templateType: TemplateType;
  public templateTypeEnum = TemplateType;
  @Input() get template_type(): string {
    return this.templateType;
  }
  
  set template_type(value: TemplateType) {
    this.templateType = value || null;
  }

  constructor(
    private router: Router,
    private templateService: TemplateService,
    private globalService: GlobalService,
    private recipientfieldsService: RecipientfieldsService,
    public modalService: NgbActiveModal,
    private fb: FormBuilder,
    private helperService: HelperService,
    private translocoService: TranslocoService
  ) { }

  ngOnInit() {
    const contentUuid = this.uuid();
    this.add_template_form = this.fb.group({
      name: ['', Validators.required],
      document_type_id: [null],
      content: [this.globalService.defaultEditor({uuid:contentUuid})],
      template_roles: this.fb.array([]),
      type: [this.templateType],
    });
    const block = {};
    block[contentUuid] = contentBlock.block({ uuid: contentUuid });
    this.globalService.fields_data['blocks'] = block;
    this.addConvertToEformSettings();
  }

  // Function to add convert_to_eform_settings conditionally
  addConvertToEformSettings() {
    if (this.add_template_form.get('type')?.value === TemplateType.EFORM) {
      const eform_message_uuid = this.uuid();
      const messageContent = this.globalService.defaultEditor({uuid:eform_message_uuid});
      this.add_template_form.addControl('eform_message', this.fb.control(messageContent));
      this.add_template_form.addControl(
        'convert_to_eform_settings',
        this.fb.group({
          id: [null],
          redirect_url: [''],
          template_id: [null],
          participant: [0],
          backround: [0],
          arrows: [0],
          users: [[]],
          unique_id: [''],
          logo: [''],
          headline: [''],
          subtitle: [''],
          button_color: ['#000000'],
          confirmation_text_color: ['#000000'],
          eform_steps: this.fb.array(this.helperService.eformSteps(steps())),
        })
      );
      const block = {};
      block[eform_message_uuid] = contentBlock.block({ uuid: eform_message_uuid });
      this.globalService.fields_data['blocks'] = block;
    }
  }

  addNewTemplate() {
    this.submitted = true;
    if (this.add_template_form.invalid) {
      return;
    }
    this.submitted = false;
    this.addTemaplteLoadder = true;
    this.recipientfieldsService.fetchRecipientFields().subscribe({
      next: (roles) => {
        let template_roles = roles || [];
        if(this.add_template_form.get('type')?.value === TemplateType.EFORM) {
          template_roles = template_roles.filter((r, index) => index === 0).map((role) => ({...role, ...{invitation_type:InvitationThroughEnum.SAME_DEVICE}}));
        }
        const newRole: FormGroup[] = this.helperService.getRoles(template_roles);
        newRole.forEach(newRole => {
          this.template_roles.push(newRole);
        });
        this.add_template_form.value['fields_data'] = this.globalService.fields_data;
        this.templateService.addNewTemplate(this.add_template_form.value).subscribe({
          next: (template) => {
            this.modalService.close();
            this.globalService.toastrSuccess(this.translocoService.translate("Success toaster message for add template - (template section) - Template has been created"));
            this.addTemaplteLoadder = false;
            this.router.navigateByUrl(`/edit-template/${template.id}`);
          },
          error: (error) => {
            this.globalService.toastrError(error);
            this.addTemaplteLoadder = false;
          }
        })
      },

      error: (error) => {
        this.globalService.toastrError(error);
        this.addTemaplteLoadder = false;
      }
    });  
  }

  /**
   * Get template roles
   * @access
   */
  get template_roles() {
    return this.add_template_form.controls["template_roles"] as FormArray;
  }
}
